import { createStore } from 'vuex';
import modules from './modules';

const store = createStore({
    state: {},
    mutations: {},
    actions: {},
    modules,
});

export default store;
